
const removeMinorVersions = (arr) => {
    return arr.map(version => {
       const splitVersion = version.split(".");
       return `${splitVersion[0]}.${splitVersion[1]}`;
    });
    }


    export default removeMinorVersions;